import Tabs, { Tab } from "@albertsons/uds/molecule/Tabs";
import ActiveInventoryTab from "../../common/tab/InterfacesTab/ActiveInventoryTab";
import "./L2Interfaces.css";
import ActiveInventoryHistoryTab from "../../common/tab/InterfacesHistory/ActiveInventoryHistoryTab";
import Header from "@albertsons/uds/molecule/Header";
import React from "react";

const ActiveInventory = () => {
  return (
    <div>
      <Header title="Active Inventory MA NON PROD DATA Refresh"></Header>

      <div className="col-12 margin-left">
        <Tabs variant="light">
          <Tab>
            <Tab.Header>Active Inventory Data Load</Tab.Header>
            <Tab.Content>
              <ActiveInventoryTab />
            </Tab.Content>
          </Tab>
          <Tab>
            <Tab.Header>Active Inventory History</Tab.Header>
            <Tab.Content>
              <ActiveInventoryHistoryTab />
            </Tab.Content>
          </Tab>
        </Tabs>
      </div>
    </div>
  );
};

export default ActiveInventory;
